import {
  Button,
  Center,
  CloseButton,
  em,
  rem,
  ScrollArea,
  SimpleGrid,
  Text,
  Title,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import type { ContextModalProps } from '@mantine/modals';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';
import CustomImage from '../custom-image';

const GoodsInforModal = ({ context }: ContextModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${em(767)})`);
  const tCommon = useTranslations('common');

  const handleClose = () => {
    context.closeAll();
  };

  return (
    <Fragment>
      <CloseButton
        pos="absolute"
        iconSize={rem(24)}
        variant="transparent"
        onClick={handleClose}
        c="neutral.6"
        top={rem(16)}
        style={
          isMobile
            ? {
                left: rem(16),
                outline: 'none',
              }
            : {
                right: rem(16),
                outline: 'none',
              }
        }
      />
      <Center mb={rem(24)}>
        <CustomImage
          width={352}
          height={144}
          src="/static/images/goods-infor-image.webp"
          alt="/static/images/goods-infor-image.webp"
        />
      </Center>
      <Title mb={rem(8)} ta="center" order={3} c="neutral.7">
        Thông tin hàng hóa
      </Title>
      <ScrollArea.Autosize mb={rem(16)}>
        <Text
          px={{ base: rem(16), sm: rem(24) }}
          size="sm"
          fw={500}
          c="neutral.6"
          component="div"
          ta="center"
        >
          Hãy chọn tổng kích cỡ và nhập tổng khối lượng hàng hóa để Ahamove sắp
          xếp xe và tài xế phù hợp cho bạn.
        </Text>
      </ScrollArea.Autosize>
      <SimpleGrid w="100%" cols={1} spacing="md">
        <Button
          fullWidth
          mih={rem(48)}
          radius={rem(4)}
          fw={700}
          onClick={handleClose}
        >
          {tCommon('got_it')}
        </Button>
      </SimpleGrid>
    </Fragment>
  );
};

export default GoodsInforModal;
